<template>
    <div :class="'img-' + size" class="custom-icon">
        <svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M49 125V89a4 4 0 014-4h24a4 4 0 014 4v36h0" class="highlight" stroke="#00BBDC"/><path d="M66.99 6.757l18.046 15.997-.035-3.732a3 3 0 012.972-3.028h12.015a3 3 0 013 2.96l.263 19.946 23.74 21.044a3 3 0 01-1.99 5.245l-10.005-.001-.06 56.815a3 3 0 01-3 2.997h-92.87a2.998 2.998 0 01-2.999-3l.028-56.812H4.998a3 3 0 01-1.99-5.244L63.01 6.757a3 3 0 013.98 0z" class="path" stroke="#0C2340"/></g></svg>
    </div>
</template>

<script>
    export default {
        props: {
            size: {
                type: String,
                default: '4x'
            }
        }
    }
</script>